import { Differ } from './Differ';

export default Differ;
